import { z } from 'zod';
/**
 * The outlines of every region as one PMTiles archive of vector tiles — the
 * bytes of the archive, or of the byte range asked for. A client reads it a
 * range at a time, so the body is never the whole file.
 */ export const GetRegionTilesResponseSchema = z.instanceof(Blob).optional();
/**
 * The tile layers, one per region level the archive carries, and the zoom
 * range each is cut for. A map shows one layer at a time and colours it by
 * the region id each feature is promoted by.
 */ export const REGION_TILE_LAYERS = {
    // Each level is cut from a zoom where its country still fits the screen
    // (Germany on a small laptop sits just under zoom 5) up to where the level
    // above it is drawn, so its borders stay aligned over the finer fill; a
    // map zoomed deeper reuses the deepest tile.
    country: {
        minzoom: 0,
        maxzoom: 6
    },
    state: {
        minzoom: 3,
        maxzoom: 9
    },
    district: {
        minzoom: 4,
        maxzoom: 10
    },
    municipality: {
        minzoom: 5,
        maxzoom: 12
    }
};
/** The feature property every layer promotes to the feature id: the region's id. */ export const REGION_TILE_ID_PROPERTY = 'id';

//# sourceMappingURL=get-region-tiles.schema.js.map